export type CreatorName = {
  nickname: string | null;
  handle: string | null;
};

export const getCreatorName = (nickname: string | null | undefined, handle: string | null | undefined): CreatorName => {
  const bareHandle = handle?.trim().replace(/^@/, "") || null;
  const cleanNickname = nickname?.trim() || null;
  const isHandle = !!cleanNickname && cleanNickname.replace(/^@/, "").toLowerCase() === bareHandle?.toLowerCase();
  return {
    nickname: isHandle ? null : cleanNickname,
    handle: bareHandle ? `@${bareHandle}` : null,
  };
};
